import React, { useState, useEffect } from "react";
import { MessageSquare, Clock, ArrowRight, User } from "lucide-react";
import { supabase } from "../../../lib/supabase";

const QACard = ({ question, onView, onViewProfile, userId, userCampus }) => {
  const [answerCount, setAnswerCount] = useState(0);

  useEffect(() => {
    fetchAnswerCount();
  }, [question.id]);

  const fetchAnswerCount = async () => {
    const { count, error } = await supabase
      .from("comments")
      .select("*", { count: 'exact', head: true })
      .eq("post_id", question.id);
    
    if (!error) setAnswerCount(count || 0);
  };

  const getTimeAgo = (dateStr) => {
    const date = new Date(dateStr);
    const now = new Date();
    const seconds = Math.floor((now - date) / 1000);
    if (seconds < 60) return "Just now";
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;
    return `${Math.floor(hours / 24)}d ago`;
  };

  return (
    <div 
        onClick={onView}
        className="glass-card premium-shadow p-6 transition-all hover:scale-[1.01] duration-300 cursor-pointer group"
    >
        {/* Top Bar */}
        <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-4">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onViewProfile?.(question.author_id);
                  }}
                  className="shrink-0 hover:opacity-80 transition-opacity"
                >
                  {question.profiles?.avatar_url ? (
                    <img
                      src={question.profiles.avatar_url}
                      alt={question.author_alias}
                      className="w-10 h-10 rounded-xl object-cover border border-indigo-100 dark:border-indigo-800 shadow-sm"
                    />
                  ) : (
                    <div className="w-10 h-10 rounded-xl bg-indigo-50 dark:bg-indigo-900/30 flex items-center justify-center text-indigo-600 dark:text-indigo-400 font-bold border border-indigo-100 dark:border-indigo-800 shadow-sm">
                      {question.author_alias?.[0]}
                    </div>
                  )}
                </button>
                <div>
                    <div className="flex items-center gap-2">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onViewProfile?.(question.author_id);
                          }}
                          className="font-black text-slate-900 dark:text-white leading-tight transition-colors hover:text-indigo-600 dark:hover:text-indigo-400"
                        >
                            {question.author_alias}
                        </button>
                        {question.campus_code && (
                            <span className={`text-[9px] px-2 py-0.5 rounded-lg font-black uppercase tracking-[0.1em] ${
                                question.campus_code === userCampus 
                                ? "bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-400"
                                : "bg-slate-50 dark:bg-slate-800/50 text-slate-500 dark:text-slate-500"
                            }`}>
                                {question.campus_code}
                            </span>
                        )}
                    </div>
                    <div className="flex items-center gap-2 mt-1">
                        <span className="text-[10px] text-slate-400 dark:text-slate-500 font-bold uppercase tracking-widest">{question.category}</span>
                        <div className="w-1 h-1 rounded-full bg-slate-200 dark:bg-slate-800"></div>
                        <span className="text-[10px] text-slate-400 dark:text-slate-500 font-bold uppercase tracking-widest">{getTimeAgo(question.created_at)}</span>
                    </div>
                </div>
            </div>
            <div className="w-10 h-10 rounded-xl flex items-center justify-center text-slate-300 dark:text-slate-700 bg-slate-50 dark:bg-white/5 group-hover:bg-indigo-600 group-hover:text-white transition-all transform group-hover:rotate-12">
                <ArrowRight size={18} />
            </div>
        </div>

        {/* Content */}
        <h3 className="text-xl font-bold text-slate-900 dark:text-slate-100 leading-snug mb-6 group-hover:translate-x-1 transition-transform duration-500">
            {question.content}
        </h3>

        {/* Footer */}
        <div className="flex items-center gap-2 pt-6 border-t border-slate-100 dark:border-white/5">
            <div className="flex items-center gap-3 px-4 py-2 bg-slate-50 dark:bg-white/5 rounded-xl text-slate-500 dark:text-slate-400 group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">
                <MessageSquare size={16} />
                <span className="text-xs font-black uppercase tracking-wider">
                    {answerCount} {answerCount === 1 ? 'Response' : 'Responses'}
                </span>
            </div>
        </div>
    </div>
  );
};

export default QACard;
